if (!window.BelleriveI18n) {
  const strings = {"accessoires":"Accessoires","aucun_avis_dans_cette_categorie_pour_le_moment":"Aucun avis dans cette catégorie pour le moment.","avis_indisponibles_error":"Avis indisponibles — __BLV_error__","brassiere":"Brassière","chargement_des_avis":"Chargement des avis…","choisissez_une_note":"Choisissez une note.","cliente":"Cliente","correct":"Correct","decevant":"Décevant","ecrivez_quelques_mots_sur_le_produit":"Écrivez quelques mots sur le produit.","enregistrement_impossible":"Enregistrement impossible.","envoi_de_name_impossible":"Envoi de « __BLV_name__ » impossible.","envoi_des_fichiers_impossible":"Envoi des fichiers impossible.","envoi_index_total":"Envoi __BLV_index__ / __BLV_total__…","format_de_fichier_inattendu":"format de fichier inattendu","image_de_la_video_jointe_a_lavis":"Image de la vidéo jointe à l’avis","indiquez_votre_prenom":"Indiquez votre prénom.","legging":"Legging","les_avis_ne_sont_pas_disponibles_pour_le_moment":"Les avis ne sont pas disponibles pour le moment.","lire_plus":"Lire plus","media_joint_a_lavis":"Média joint à l’avis","name_depasse_100_mo":"« __BLV_name__ » dépasse 100 Mo.","number_avis":"__BLV_number__ avis","number_fichiers_maximum":"__BLV_number__ fichiers maximum.","parfait":"Parfait","photo_jointe_a_lavis":"Photo jointe à l’avis","preparation_des_fichiers":"Préparation des fichiers…","rating_etoiles_sur_5":"__BLV_rating__ étoiles sur 5","renseignez_lurl_de_lapi_dans_les_reglages_de_la_section":"Renseignez l’URL de l’API dans les réglages de la section.","reponse_http_status":"réponse HTTP __BLV_status__","retirer_name":"Retirer __BLV_name__","serveur_injoignable_ou_origine_non_autorisee_cors":"serveur injoignable ou origine non autorisée (CORS)","short":"Short","tenue_complete":"Tenue complète","tous_les_avis":"Tous les avis","tres_bien":"Très bien","tres_decue":"Très déçue","une_erreur_est_survenue":"Une erreur est survenue.","url_de_lapi_non_renseignee_dans_les_reglages":"URL de l’API non renseignée dans les réglages.","video":"VIDÉO","votre_avis_sur_ce_produit":"Votre avis sur ce produit"};
  window.BelleriveI18n = {
    locale: document.documentElement.lang || 'fr',
    translated: false,
    t: (key, values = {}) => String(strings[key] ?? '').replace(/__BLV_(\w+)__/g, (match, name) => Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match)
  };
}
/**
 * Bellerive — logique partagée des avis.
 *
 * Un seul endroit pour charger les avis et en envoyer un nouveau, afin que la
 * section d'affichage, le formulaire et le pop-up produit ne puissent jamais
 * diverger. Tout ce qui parle à l'API passe par ici.
 */
window.BelleriveAvis = (() => {
  const MAX_EDGE = 1600; // px, côté le plus long après compression
  const JPEG_QUALITY = 0.82;

  const cache = new Map(); // url → promesse de chargement, partagée par tous les blocs

  /** Catégorie produit, identique côté Worker et côté thème. */
  function categorie(valeur) {
    const clef = String(valeur || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
    if (/ensemble|tenue|le-pack-bellerive|le-pack-ventre-plat/.test(clef)) return 'outfit';
    if (/brassiere/.test(clef)) return 'bra';
    if (/legging/.test(clef)) return 'legging';
    if (/short/.test(clef)) return 'short';
    return 'accessory';
  }

  /**
   * Catégories d'un avis, toujours sous forme de tableau.
   * Un avis qui parle du short et du legging relève des deux, plus « outfit ».
   * On tolère les anciens formats : catégorie simple, ou aucune.
   */
  function categoriesDe(avis) {
    if (Array.isArray(avis.categories) && avis.categories.length) return avis.categories;
    if (avis.category) return [avis.category];
    return [categorie(avis.handle)];
  }

  /** L'avis relève-t-il de cette catégorie ? */
  function releveDe(avis, cle) {
    return !cle || categoriesDe(avis).includes(cle);
  }

  /** N'accepte qu'une URL https : évite d'injecter n'importe quoi dans le DOM. */
  function imageSure(url) {
    try {
      const adresse = new URL(url);
      return adresse.protocol === 'https:' ? adresse.href : null;
    } catch {
      return null;
    }
  }

  /** Normalise les médias d'un avis, quelle que soit la version du format. */
  function medias(avis) {
    const brut =
      Array.isArray(avis.media) && avis.media.length
        ? avis.media
        : avis.image
          ? [{ type: 'image', url: avis.image }]
          : [];
    return brut
      .map((item) => ({
        type: item.type === 'video' ? 'video' : 'image',
        url: imageSure(item.url),
        thumb: imageSure(item.thumb),
      }))
      .filter((item) => item.url);
  }

  /**
   * Charge les avis. Le résultat est mis en commun entre tous les blocs de la
   * page : trois blocs d'avis ne déclenchent qu'une seule requête.
   * `rafraichir` force un rechargement en contournant les caches.
   */
  function chargerAvis(url, { rafraichir = false } = {}) {
    if (rafraichir) cache.delete(url);
    if (!cache.has(url)) {
      const adresse = rafraichir ? url + (url.includes('?') ? '&' : '?') + 't=' + Date.now() : url;
      const promesse = fetch(adresse, rafraichir ? { cache: 'reload' } : undefined)
        .catch(() => {
          throw new Error(window.BelleriveI18n.t("serveur_injoignable_ou_origine_non_autorisee_cors"));
        })
        .then((reponse) => {
          if (!reponse.ok) throw new Error(window.BelleriveI18n.t("reponse_http_status", {status: reponse.status}));
          return reponse.json();
        })
        .then((donnees) => {
          if (!Array.isArray(donnees.reviews)) throw new Error(window.BelleriveI18n.t("format_de_fichier_inattendu"));
          return donnees;
        })
        .catch((erreur) => {
          cache.delete(url);
          throw erreur;
        });
      cache.set(url, promesse);
    }
    return cache.get(url);
  }

  /** Vide le cache : à appeler après l'envoi d'un avis. */
  function viderCache() {
    cache.clear();
  }

  /** Réduit une photo dans le navigateur. Renvoie l'original si ça échoue. */
  async function compresser(fichier) {
    if (!fichier.type.startsWith('image/')) return fichier;
    try {
      const bitmap = await createImageBitmap(fichier);
      const facteur = Math.min(1, MAX_EDGE / Math.max(bitmap.width, bitmap.height));
      const toile = document.createElement('canvas');
      toile.width = Math.round(bitmap.width * facteur);
      toile.height = Math.round(bitmap.height * facteur);
      toile.getContext('2d').drawImage(bitmap, 0, 0, toile.width, toile.height);
      bitmap.close?.();

      const blob = await new Promise((resolve) => toile.toBlob(resolve, 'image/jpeg', JPEG_QUALITY));
      if (!blob || blob.size >= fichier.size) return fichier;

      return new File([blob], fichier.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' });
    } catch {
      return fichier; // HEIC non décodable, mémoire insuffisante… on envoie tel quel
    }
  }

  /**
   * Envoie un avis complet : compression, dépôt des fichiers chez Shopify, puis
   * création de l'avis. `surEtape(message)` sert à alimenter un indicateur.
   */
  async function envoyerAvis(api, donnees, surEtape = () => {}) {
    const racine = String(api || '').replace(/\/+$/, '');
    if (!racine) throw new Error(window.BelleriveI18n.t("url_de_lapi_non_renseignee_dans_les_reglages"));

    const fichiers = donnees.files || [];
    let media = [];

    if (fichiers.length) {
      surEtape(window.BelleriveI18n.t("preparation_des_fichiers"));
      const prets = await Promise.all(fichiers.map(compresser));

      const reponse = await fetch(`${racine}/api/upload-targets`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          files: prets.map((f) => ({ filename: f.name, mimeType: f.type, fileSize: f.size })),
        }),
      });
      const cibles = await reponse.json();
      if (!reponse.ok) throw new Error(cibles.error || window.BelleriveI18n.t("envoi_des_fichiers_impossible"));

      let envoye = 0;
      for (const [index, cible] of cibles.targets.entries()) {
        surEtape(window.BelleriveI18n.t("envoi_index_total", {index: ++envoye, total: prets.length}));
        const formulaire = new FormData();
        for (const parametre of cible.parameters) formulaire.append(parametre.name, parametre.value);
        formulaire.append('file', prets[index]); // doit rester le dernier champ
        const depot = await fetch(cible.url, { method: 'POST', body: formulaire });
        if (!depot.ok) throw new Error(window.BelleriveI18n.t("envoi_de_name_impossible", {name: prets[index].name}));
        media.push({ resourceUrl: cible.resourceUrl, kind: cible.kind });
      }
    }

    surEtape('Enregistrement…');
    const reponse = await fetch(`${racine}/api/reviews`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        rating: donnees.rating,
        title: donnees.title || '',
        text: donnees.text,
        name: donnees.name,
        website: donnees.website || '',
        productId: donnees.productId,
        handle: donnees.handle,
        media,
      }),
    });
    const resultat = await reponse.json();
    if (!reponse.ok) throw new Error(resultat.error || window.BelleriveI18n.t("enregistrement_impossible"));

    viderCache(); // le prochain affichage ira rechercher les avis à jour
    return resultat;
  }


  function regrouperAvis(avisList) {
    const nomsVus = new Set();
    return avisList.filter(avis => {
      const nom = String(avis.name || '').normalize('NFC').trim().replace(/\s+/g, ' ').toLocaleLowerCase('fr');
      if (!nom) return true;
      if (nomsVus.has(nom)) return false;
      nomsVus.add(nom);
      return true;
    });
  }

  function produitsAvis() {
    return '';
  }

  return { regrouperAvis, produitsAvis, categorie, categoriesDe, releveDe, imageSure, medias, chargerAvis, viderCache, compresser, envoyerAvis };
})();


/* ═══════════════════════════════════════════════════════════════════════
 * Les trois composants d'affichage.
 *
 * Ils vivaient auparavant dans chaque fichier .liquid, ce qui obligeait a
 * recopier la moindre correction a trois endroits. Ils sont desormais ici,
 * ensemble : une correction, un seul fichier a remplacer.
 * ═══════════════════════════════════════════════════════════════════════ */


/* ─────────────── Section d'affichage des avis ─────────────── */
(()=>{
if(customElements.get('bellerive-imported-reviews'))return;
const requests=new Map();
function load(url){if(!requests.has(url)){const p=fetch(url).catch(()=>{throw Error(window.BelleriveI18n.t("serveur_injoignable_ou_origine_non_autorisee_cors"));}).then(r=>{if(!r.ok)throw Error('réponse HTTP '+r.status);return r.json();}).catch(e=>{requests.delete(url);throw e;});requests.set(url,p);}return requests.get(url);}
function el(tag,cls,text){const node=document.createElement(tag);if(cls)node.className=cls;if(text!==undefined)node.textContent=text;return node;}
function reviewCategory(value){const key=String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();if(/ensemble|tenue|le-pack-bellerive|le-pack-ventre-plat/.test(key))return 'outfit';if(/brassiere/.test(key))return 'bra';if(/legging/.test(key))return 'legging';if(/short/.test(key))return 'short';return 'accessory';}
function appartient(review,cle){if(!cle)return true;const liste=Array.isArray(review.categories)&&review.categories.length?review.categories:(review.category?[review.category]:[reviewCategory(review.handle)]);return liste.includes(cle);}
const HINTS=['',window.BelleriveI18n.t("tres_decue"),window.BelleriveI18n.t("decevant"),window.BelleriveI18n.t("correct"),window.BelleriveI18n.t("tres_bien"),window.BelleriveI18n.t("parfait")];
function bibliotheque(){if(window.BelleriveAvis)return Promise.resolve(window.BelleriveAvis);return new Promise(resolve=>{const t=setInterval(()=>{if(window.BelleriveAvis){clearInterval(t);resolve(window.BelleriveAvis);}},30);});}
function safeImage(url){try{const u=new URL(url);return u.protocol==='https:'?u.href:null;}catch{return null;}}
class Reviews extends HTMLElement{
 connectedCallback(){if(this.ready)return;if(!this.querySelector('[data-review-config]')){if((this.attentes=(this.attentes||0)+1)>120){console.error('[Avis Bellerive] configuration introuvable');return;}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>this.connectedCallback(),{once:true});else requestAnimationFrame(()=>this.connectedCallback());return;}this.ready=true;this.init().catch(error=>{console.error('[Avis Bellerive]',error);const message=this.querySelector('[data-message]');if(!message)return;message.hidden=false;message.textContent=this.cfg&&this.cfg.editor?('Erreur : '+(error&&error.message||error)):window.BelleriveI18n.t("les_avis_ne_sont_pas_disponibles_pour_le_moment");});}
 async init(){
  this.cfg=JSON.parse(this.querySelector('[data-review-config]').textContent);this.grid=this.querySelector('.br-review-grid');this.message=this.querySelector('[data-message]');this.actions=this.querySelector('.br-review-actions');this.dialog=this.querySelector('dialog');this.desktop=matchMedia('(min-width:700px)');this.count=this.cfg.initial;
  this.querySelector('[data-more]').onclick=()=>{this.count+=this.cfg.initial;this.render();};
  this.querySelector('[data-less]').onclick=()=>{this.count=this.cfg.initial;this.render();this.scrollIntoView({block:'start',behavior:'auto'});};
  this.querySelector('.br-review-close').onclick=()=>this.dialog.close();
  this.dialog.addEventListener('close',()=>this.opener?.focus());
  this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
  this.resize=()=>this.render();this.desktop.addEventListener('change',this.resize);
  if(this.cfg.formEnabled)this.prepareForm();
  try{
   const data=await load(this.cfg.url==='bellerive-avis.json'?this.cfg.assetUrl:this.cfg.url);
   if(!Array.isArray(data.reviews))throw Error('Format');
   this.allReviews=data.reviews.filter(r=>Number.isInteger(r.rating)&&r.rating>=1&&r.rating<=5);
   this.category=this.cfg.handle?reviewCategory(this.cfg.handle+' '+(this.cfg.productType||'')+' '+(this.cfg.productTitle||'')):null;
   const filters=this.querySelector('.br-review-filters');filters.hidden=false;
   for(const [key,label] of [[null,window.BelleriveI18n.t("tous_les_avis")],['bra',window.BelleriveI18n.t("brassiere")],['short',window.BelleriveI18n.t("short")],['legging',window.BelleriveI18n.t("legging")],['outfit',window.BelleriveI18n.t("tenue_complete")],['accessory',window.BelleriveI18n.t("accessoires")]]){
    const button=el('button','br-review-filter',label);button.type='button';button.dataset.category=key===null?'':key;
    button.onclick=()=>{this.category=key===null?null:(this.category===key?null:key);this.applyCategory();};filters.append(button);
   }
   const heading=this.querySelector('[data-heading]');heading.textContent=this.cfg.heading;heading.hidden=!this.cfg.heading;
   this.applyCategory();
  }catch(error){console.error('[Avis Bellerive] chargement',error);this.message.hidden=false;this.message.textContent=this.cfg.editor?('Avis non chargés — '+(error&&error.message||error)+' · Vérifiez l’URL du fichier d’avis dans les réglages.'):window.BelleriveI18n.t("les_avis_ne_sont_pas_disponibles_pour_le_moment");}
 }
 applyCategory(){
  this.count=this.cfg.initial;
  this.reviews=window.BelleriveAvis.regrouperAvis(this.allReviews.filter(r=>appartient(r,this.category)));
  this.querySelectorAll('[data-category]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.category===(this.category||''))));
  this.message.hidden=this.reviews.length>0;this.message.textContent=window.BelleriveI18n.t("aucun_avis_dans_cette_categorie_pour_le_moment");
  this.render();this.grid.scrollLeft=0;
 }
 prepareForm(){
  this.formDialog=this.querySelector('.br-form-dialog');if(!this.formDialog)return;
  this.form=this.querySelector('[data-form]');this.done=this.querySelector('[data-done]');
  this.formStatus=this.querySelector('[data-status]');this.submit=this.querySelector('[data-submit]');this.files=[];
  this.querySelector('[data-open-form]').onclick=()=>{this.formDialog.showModal();};
  this.querySelectorAll('[data-close-form]').forEach(b=>b.onclick=()=>this.formDialog.close());
  this.formDialog.addEventListener('click',e=>{if(e.target===this.formDialog){const r=this.formDialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.formDialog.close();}});
  const group=this.querySelector('[data-stars]'),hint=this.querySelector('[data-hint]');
  const paint=v=>group.querySelectorAll('label').forEach((l,i)=>{l.style.color=i<v?'#00b879':'#dcdce6';});
  group.querySelectorAll('input').forEach(input=>input.addEventListener('change',()=>{this.rating=Number(input.value);paint(this.rating);hint.textContent=HINTS[this.rating];}));
  group.querySelectorAll('label').forEach((l,i)=>l.addEventListener('mouseenter',()=>paint(i+1)));
  group.addEventListener('mouseleave',()=>paint(this.rating||0));
  const text=this.form.elements.text,counter=this.querySelector('[data-counter]');
  text.addEventListener('input',()=>{counter.textContent=text.value.length+' / 3000';});
  const input=this.querySelector('[data-files]');
  if(input){const drop=this.querySelector('[data-drop]');
   input.addEventListener('change',()=>{this.addFiles(input.files);input.value='';});
   ['dragenter','dragover'].forEach(t=>drop.addEventListener(t,e=>{e.preventDefault();drop.classList.add('is-over');}));
   ['dragleave','drop'].forEach(t=>drop.addEventListener(t,()=>drop.classList.remove('is-over')));
   drop.addEventListener('drop',e=>{e.preventDefault();this.addFiles(e.dataTransfer.files);});}
  this.form.addEventListener('submit',e=>{e.preventDefault();this.sendReview();});
 }
 addFiles(list){const room=this.cfg.maxMedia-this.files.length;if(room<=0)return this.say(window.BelleriveI18n.t("number_fichiers_maximum", {number: this.cfg.maxMedia}),true);
  for(const file of Array.from(list).slice(0,room)){const video=file.type.startsWith('video/');
   if(video&&!this.cfg.allowVideo)continue;
   if(video&&file.size>100*1024*1024){this.say(window.BelleriveI18n.t("name_depasse_100_mo", {name: file.name}),true);continue;}
   this.files.push(file);}
  this.previews();}
 previews(){const zone=this.querySelector('[data-previews]');if(!zone)return;zone.replaceChildren();
  this.files.forEach((file,index)=>{const item=el('div','br-preview');const url=URL.createObjectURL(file);const video=file.type.startsWith('video/');
   const media=el(video?'video':'img');media.src=url;if(video){media.muted=true;media.playsInline=true;}else media.alt='';
   media.addEventListener('load',()=>URL.revokeObjectURL(url),{once:true});item.append(media);
   if(video)item.append(el('span','br-badge',window.BelleriveI18n.t("video")));
   const remove=el('button','','✕');remove.type='button';remove.setAttribute('aria-label',window.BelleriveI18n.t("retirer_name", {name: file.name}));
   remove.onclick=()=>{this.files.splice(index,1);this.previews();};item.append(remove);zone.append(item);});}
 say(message,error=false){this.formStatus.textContent=message;this.formStatus.classList.toggle('is-error',error);}
 async sendReview(){
  const data=new FormData(this.form),rating=Number(data.get('rating'));
  if(!rating)return this.say(window.BelleriveI18n.t("choisissez_une_note"),true);
  if(!String(data.get('text')||'').trim())return this.say(window.BelleriveI18n.t("ecrivez_quelques_mots_sur_le_produit"),true);
  if(!String(data.get('name')||'').trim())return this.say(window.BelleriveI18n.t("indiquez_votre_prenom"),true);
  this.submit.disabled=true;
  try{
   const lib=await bibliotheque();
   await lib.envoyerAvis(this.cfg.api,{rating,title:data.get('title')||'',text:data.get('text'),name:data.get('name'),
    website:data.get('website')||'',productId:this.cfg.productId,handle:this.cfg.handle,files:this.files},
    etape=>this.say(etape));
   this.form.hidden=true;this.done.hidden=false;
   // L'avis publie doit apparaitre sans recharger la page.
   const fresh=await lib.chargerAvis(this.cfg.url,{rafraichir:true});
   this.allReviews=fresh.reviews.filter(r=>Number.isInteger(r.rating)&&r.rating>=1&&r.rating<=5);
   this.applyCategory();
  }catch(error){this.say(error.message||window.BelleriveI18n.t("une_erreur_est_survenue"),true);}
  finally{this.submit.disabled=false;}
 }
 disconnectedCallback(){this.desktop?.removeEventListener('change',this.resize);}
 info(review){const content=el('div');const head=el('div','br-review-head');const parts=String(review.name||window.BelleriveI18n.t("cliente")).split(/\s+/);const avatar=el('span','br-review-avatar',parts.slice(0,2).map(p=>p[0]||'').join('').toUpperCase());const palette=["#FFF699", "#FEEFD4", "#FFEDDD", "#FEECEA", "#F1F4BD", "#DEF7D8", "#CEFAEA", "#DEF4F9", "#E8F1FE", "#F4EDFF", "#FFEAFE", "#FFEBF1"];let hash=0;for(const char of String(review.id||review.name||''))hash=(Math.imul(hash,31)+char.charCodeAt(0))|0;avatar.style.backgroundColor=palette[(hash>>>0)%palette.length];head.append(avatar);const names=el('div');names.append(el('p','br-review-name',review.name||window.BelleriveI18n.t("cliente")));const date=new Date(review.date);if(!isNaN(date)){const time=el('time','br-review-date',date.toLocaleDateString(window.BelleriveI18n.locale,{day:'numeric',month:'long',year:'numeric'}));time.dateTime=date.toISOString();names.append(time);}head.append(names);content.append(head);const stars=el('div','br-review-stars');stars.setAttribute('role','img');stars.setAttribute('aria-label',window.BelleriveI18n.t("rating_etoiles_sur_5", {rating: review.rating}));const fallback=()=>{stars.replaceChildren();for(let i=1;i<=5;i++){const star=el('span','br-review-star'+(i<=review.rating?' filled':''),'★');star.setAttribute('aria-hidden','true');stars.append(star);}};const custom=this.cfg.starImages?.[review.rating];if(custom){const img=el('img','br-review-stars-image');img.src=custom;img.alt='';img.setAttribute('aria-hidden','true');img.addEventListener('error',fallback,{once:true});stars.append(img);}else fallback();content.append(stars);if(review.title)content.append(el('p','br-review-title',review.title));content.append(el('p','br-review-text',review.text||''));const products=window.BelleriveAvis.produitsAvis(review);if(products)content.append(el('p','br-review-date',products));return content;}
 mediaItems(review){const raw=Array.isArray(review.media)&&review.media.length?review.media:(review.image?[{type:'image',url:review.image}]:[]);return raw.map(item=>({type:item.type==='video'?'video':'image',url:safeImage(item.url),thumb:safeImage(item.thumb)})).filter(item=>item.url);}
 cover(review){const items=this.mediaItems(review);if(!items.length)return null;const first=items[0];const wrap=el('div','br-review-mediawrap');let node;if(first.type==='video'&&!first.thumb){node=el('video','br-review-media');node.src=first.url;node.muted=true;node.playsInline=true;node.preload='metadata';}else{node=el('img','br-review-media');node.src=first.type==='video'?first.thumb:first.url;node.alt=window.BelleriveI18n.t("media_joint_a_lavis");node.loading='lazy';}node.addEventListener('error',()=>wrap.remove());wrap.append(node);if(first.type==='video')wrap.append(el('span','br-review-play'));if(items.length>1)wrap.append(el('span','br-review-count','+'+(items.length-1)));return wrap;}
 gallery(review){const items=this.mediaItems(review);if(!items.length)return null;const grid=el('div','br-review-gallery');for(const item of items){if(item.type==='video'){const video=el('video');video.src=item.url;video.controls=true;video.playsInline=true;video.preload='metadata';if(item.thumb)video.poster=item.thumb;video.addEventListener('error',()=>{if(item.thumb){const repli=el('img');repli.src=item.thumb;repli.alt=window.BelleriveI18n.t("image_de_la_video_jointe_a_lavis");repli.loading='lazy';video.replaceWith(repli);}else video.remove();});grid.append(video);}else{const img=el('img');img.src=item.url;img.alt=window.BelleriveI18n.t("photo_jointe_a_lavis");img.loading='lazy';img.addEventListener('error',()=>img.remove());grid.append(img);}}return grid;}
 render(){if(!this.reviews)return;this.grid.replaceChildren();const shown=this.desktop.matches?this.reviews.slice(0,this.count):this.reviews;for(const review of shown){const card=el('article','br-review-card');card.append(this.info(review));if(review.text||this.mediaItems(review).length){const more=el('button','br-review-read',window.BelleriveI18n.t("lire_plus"));more.type='button';more.onclick=()=>{this.opener=more;const detail=this.querySelector('.br-review-detail');detail.replaceChildren();const media=this.gallery(review);detail.classList.toggle('has-photo',!!media);if(media)detail.append(media);detail.append(this.info(review));this.dialog.showModal();};card.append(more);}const cover=this.cover(review);if(cover)card.append(cover);this.grid.append(card);}this.actions.hidden=this.reviews.length<=this.cfg.initial;this.querySelector('[data-more]').hidden=this.count>=this.reviews.length;this.querySelector('[data-less]').hidden=this.count<=this.cfg.initial;}
}
customElements.define('bellerive-imported-reviews',Reviews);
})();


/* ─────────────── Pop-up produit ─────────────── */
(() => {
if (customElements.get('br-reviews-popup')) return;

const HINTS = ['', window.BelleriveI18n.t("tres_decue"), window.BelleriveI18n.t("decevant"), window.BelleriveI18n.t("correct"), window.BelleriveI18n.t("tres_bien"), window.BelleriveI18n.t("parfait")];
const PALETTE = ['#FFF699','#FEEFD4','#FFEDDD','#FEECEA','#F1F4BD','#DEF7D8','#CEFAEA','#DEF4F9','#E8F1FE','#F4EDFF','#FFEAFE','#FFEBF1'];
const node = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text !== undefined) n.textContent = text; return n; };

/* Le fichier partagé peut arriver après ce script : on l'attend. */
function bibliotheque() {
  if (window.BelleriveAvis) return Promise.resolve(window.BelleriveAvis);
  return new Promise((resolve) => {
    const minuteur = setInterval(() => {
      if (window.BelleriveAvis) { clearInterval(minuteur); resolve(window.BelleriveAvis); }
    }, 30);
  });
}

class ReviewPopup extends HTMLElement {
  async connectedCallback() {
    if (this.ready) return;

    /* Une 2e occurrence du bloc sur la page est upgradee avant que ses enfants
       soient analyses : sa configuration n'existe pas encore. On attend. */
    if (!this.querySelector('[data-br-config]')) {
      if ((this.attentes = (this.attentes || 0) + 1) > 120) {
        console.error('[Avis Bellerive] configuration du pop-up introuvable');
        return;
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true });
      } else {
        requestAnimationFrame(() => this.connectedCallback());
      }
      return;
    }

    this.ready = true;
    this.cfg = JSON.parse(this.querySelector('[data-br-config]').textContent);
    this.dialog = this.querySelector('dialog');
    this.trigger = this.querySelector('.br-rp-trigger');
    this.status = this.querySelector('.br-rp-status');
    this.retry = this.querySelector('.br-rp-retry');
    this.titre = this.querySelector('[data-titre]');
    this.titreInitial = this.titre.textContent;
    this.vueListe = this.querySelector('[data-vue="liste"]');
    this.vueForm = this.querySelector('[data-vue="formulaire"]');
    this.fichiers = [];

    this.lib = await bibliotheque();
    this.categorie = this.lib.categorie(this.cfg.product);

    this.trigger.onclick = () => this.open();
    this.querySelector('.br-rp-close').onclick = () => this.dialog.close();
    this.dialog.addEventListener('close', () => this.unlock());
    this.dialog.addEventListener('click', (e) => {
      if (e.target !== this.dialog) return;
      const r = this.dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.dialog.close();
    });
    this.retry.onclick = () => this.charger();

    for (const [clef, libelle] of [[null,window.BelleriveI18n.t("tous_les_avis")],['bra',window.BelleriveI18n.t("brassiere")],['short',window.BelleriveI18n.t("short")],['legging',window.BelleriveI18n.t("legging")],['outfit',window.BelleriveI18n.t("tenue_complete")],['accessory',window.BelleriveI18n.t("accessoires")]]) {
      const bouton = node('button', 'br-rp-filter', libelle);
      bouton.type = 'button';
      bouton.dataset.category = clef === null ? '' : clef;
      bouton.setAttribute('aria-pressed', String((clef === null ? '' : clef) === (this.categorie || '')));
      bouton.onclick = () => { this.categorie = clef; this.render(); };
      this.querySelector('.br-rp-filters').append(bouton);
    }

    const image = this.trigger.querySelector('img');
    if (image) {
      const repli = () => { image.style.display = 'none'; this.trigger.querySelector('.br-rp-image-fallback').hidden = false; };
      image.addEventListener('error', repli);
      if (image.complete && !image.naturalWidth) repli();
    }

    if (this.cfg.formEnabled) this.preparerFormulaire();
  }

  /* ─────────────── navigation entre les deux vues ─────────────── */

  montrer(vue) {
    const formulaire = vue === 'formulaire';
    this.vueListe.hidden = formulaire;
    this.vueForm.hidden = !formulaire;
    this.querySelector('[data-back]').hidden = !formulaire;
    const cta = this.querySelector('[data-vers-formulaire]');
    if (cta) cta.hidden = formulaire;
    this.titre.textContent = formulaire ? window.BelleriveI18n.t("votre_avis_sur_ce_produit") : this.titreInitial;
    this.vueForm.querySelector('.br-rp-scroll').scrollTop = 0;
  }

  /* ─────────────── ouverture et chargement ─────────────── */

  open() {
    if (this.dialog.open) return;
    this.dialog.showModal();
    this.ancienOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    this.verrouille = true;
    if (!this.avis) this.charger();
  }

  unlock() {
    if (this.verrouille) { document.documentElement.style.overflow = this.ancienOverflow; this.verrouille = false; }
    if (this.isConnected) this.trigger.focus({ preventScroll: true });
  }

  disconnectedCallback() { if (this.dialog?.open) this.dialog.close(); this.unlock(); }

  async charger({ rafraichir = false } = {}) {
    this.status.hidden = false;
    this.status.textContent = window.BelleriveI18n.t("chargement_des_avis");
    this.retry.hidden = true;
    try {
      const donnees = await this.lib.chargerAvis(this.cfg.url, { rafraichir });
      const minimum = Number(this.cfg.minRating) || 1;
      const vus = new Set();
      this.avis = donnees.reviews.filter((avis) => {
        const clef = avis.id || [avis.name, avis.date, avis.text].join('|');
        if (Number(avis.rating) < minimum || !String(avis.text || '').trim() || vus.has(clef)) return false;
        vus.add(clef);
        return true;
      });
      if (this.isConnected) this.render();
    } catch (erreur) {
      console.error('[Avis Bellerive] pop-up', erreur);
      this.status.textContent = window.BelleriveI18n.t("avis_indisponibles_error", {error: erreur.message || erreur});
      this.retry.hidden = false;
    }
  }

  render() {
    this.querySelectorAll('[data-category]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.category === (this.categorie || ''))));
    if (!this.avis) return;

    const liste = this.lib.regrouperAvis(this.avis.filter((a) => this.lib.releveDe(a, this.categorie)));
    this.status.hidden = false;
    this.status.textContent = liste.length
      ? window.BelleriveI18n.t("number_avis", {number: liste.length})
      : window.BelleriveI18n.t("aucun_avis_dans_cette_categorie_pour_le_moment");

    const grille = this.querySelector('.br-rp-grid');
    grille.replaceChildren();
    const morceau = document.createDocumentFragment();

    for (const avis of liste) {
      const carte = node('article', 'br-rp-card');
      const entete = node('div', 'br-rp-person');
      const nom = String(avis.name || window.BelleriveI18n.t("cliente"));

      const pastille = node('span', 'br-rp-avatar', nom.trim().split(/\s+/).slice(0, 2).map((m) => m[0] || '').join('').toUpperCase());
      pastille.setAttribute('aria-hidden', 'true');
      let empreinte = 0;
      for (const c of String(avis.id || nom)) empreinte = (Math.imul(empreinte, 31) + c.charCodeAt(0)) | 0;
      pastille.style.background = PALETTE[(empreinte >>> 0) % PALETTE.length];

      const identite = node('div');
      identite.append(node('p', 'br-rp-name', nom));
      const date = new Date(avis.date);
      if (!isNaN(date)) {
        const quand = node('time', 'br-rp-date', date.toLocaleDateString(window.BelleriveI18n.locale, { day: 'numeric', month: 'long', year: 'numeric' }));
        quand.dateTime = date.toISOString();
        identite.append(quand);
      }
      entete.append(pastille, identite);

      const etoiles = node('div', 'br-rp-stars');
      etoiles.setAttribute('role', 'img');
      etoiles.setAttribute('aria-label', window.BelleriveI18n.t("rating_etoiles_sur_5", {rating: avis.rating}));
      for (let i = 1; i <= 5; i++) {
        const etoile = node('span', i > Number(avis.rating) ? 'br-rp-empty' : '', '★');
        etoile.setAttribute('aria-hidden', 'true');
        etoiles.append(etoile);
      }

      carte.append(entete, etoiles);
      if (avis.title) carte.append(node('p', 'br-rp-cardtitle', avis.title));
      carte.append(node('p', 'br-rp-text', avis.text));
      const products = this.lib.produitsAvis(avis);
      if (products) carte.append(node('p', 'br-rp-date', products));

      const medias = this.lib.medias(avis);
      if (medias.length) {
        const premier = medias[0];
        const cadre = node('div', 'br-rp-media');
        let element;
        if (premier.type === 'video') {
          element = node('video');
          element.src = premier.url;
          element.controls = true;
          element.playsInline = true;
          element.preload = 'metadata';
          if (premier.thumb) element.poster = premier.thumb;
        } else {
          element = node('img');
          element.src = premier.url;
          element.alt = window.BelleriveI18n.t("photo_jointe_a_lavis");
          element.loading = 'lazy';
        }
        element.addEventListener('error', () => {
          // Vidéo illisible par ce navigateur : on garde au moins la vignette.
          if (premier.type === 'video' && premier.thumb) {
            const repli = node('img');
            repli.src = premier.thumb;
            repli.alt = window.BelleriveI18n.t("image_de_la_video_jointe_a_lavis");
            repli.loading = 'lazy';
            repli.addEventListener('error', () => cadre.remove());
            element.replaceWith(repli);
          } else {
            cadre.remove();
          }
        });
        cadre.append(element);
        if (medias.length > 1) cadre.append(node('span', 'br-rp-more', '+' + (medias.length - 1)));
        carte.append(cadre);
      }

      morceau.append(carte);
    }

    grille.append(morceau);
    this.vueListe.querySelector('.br-rp-scroll').scrollTop = 0;
  }

  /* ─────────────── le formulaire, dans la même fenêtre ─────────────── */

  preparerFormulaire() {
    this.form = this.querySelector('[data-form]');
    this.done = this.querySelector('[data-done]');
    this.formStatus = this.querySelector('[data-status]');
    this.submit = this.querySelector('[data-submit]');

    this.querySelector('[data-vers-formulaire]').onclick = () => this.montrer('formulaire');
    this.querySelector('[data-back]').onclick = () => this.montrer('liste');
    this.querySelector('[data-vers-liste]').onclick = () => {
      this.montrer('liste');
      this.charger({ rafraichir: true }); // l'avis tout juste publié doit apparaître
    };

    const groupe = this.querySelector('[data-stars]');
    const indice = this.querySelector('[data-hint]');
    const peindre = (valeur) => groupe.querySelectorAll('label').forEach((label, i) => {
      label.style.color = i < valeur ? '#00b67a' : '#dcdce6';
    });
    groupe.querySelectorAll('input').forEach((entree) => {
      entree.addEventListener('change', () => {
        this.note = Number(entree.value);
        peindre(this.note);
        indice.textContent = HINTS[this.note];
      });
    });
    groupe.querySelectorAll('label').forEach((label, i) => label.addEventListener('mouseenter', () => peindre(i + 1)));
    groupe.addEventListener('mouseleave', () => peindre(this.note || 0));

    const texte = this.form.elements.text;
    const compteur = this.querySelector('[data-counter]');
    texte.addEventListener('input', () => { compteur.textContent = `${texte.value.length} / 3000`; });

    const entree = this.querySelector('[data-files]');
    if (entree) {
      const zone = this.querySelector('[data-drop]');
      entree.addEventListener('change', () => { this.ajouterFichiers(entree.files); entree.value = ''; });
      ['dragenter','dragover'].forEach((type) => zone.addEventListener(type, (e) => { e.preventDefault(); zone.classList.add('is-over'); }));
      ['dragleave','drop'].forEach((type) => zone.addEventListener(type, () => zone.classList.remove('is-over')));
      zone.addEventListener('drop', (e) => { e.preventDefault(); this.ajouterFichiers(e.dataTransfer.files); });
    }

    this.form.addEventListener('submit', (e) => { e.preventDefault(); this.envoyer(); });
  }

  ajouterFichiers(liste) {
    const place = this.cfg.maxMedia - this.fichiers.length;
    if (place <= 0) return this.dire(window.BelleriveI18n.t("number_fichiers_maximum", {number: this.cfg.maxMedia}), true);
    for (const fichier of Array.from(liste).slice(0, place)) {
      const video = fichier.type.startsWith('video/');
      if (video && !this.cfg.allowVideo) continue;
      if (video && fichier.size > 100 * 1024 * 1024) { this.dire(window.BelleriveI18n.t("name_depasse_100_mo", {name: fichier.name}), true); continue; }
      this.fichiers.push(fichier);
    }
    this.apercus();
  }

  apercus() {
    const zone = this.querySelector('[data-previews]');
    if (!zone) return;
    zone.replaceChildren();
    this.fichiers.forEach((fichier, index) => {
      const item = node('div', 'br-rp-preview');
      const url = URL.createObjectURL(fichier);
      const video = fichier.type.startsWith('video/');
      const media = node(video ? 'video' : 'img');
      media.src = url;
      if (video) { media.muted = true; media.playsInline = true; } else { media.alt = ''; }
      media.addEventListener('load', () => URL.revokeObjectURL(url), { once: true });
      item.append(media);
      if (video) item.append(node('span', 'br-rp-badge', window.BelleriveI18n.t("video")));
      const retirer = node('button', '', '✕');
      retirer.type = 'button';
      retirer.setAttribute('aria-label', window.BelleriveI18n.t("retirer_name", {name: fichier.name}));
      retirer.onclick = () => { this.fichiers.splice(index, 1); this.apercus(); };
      item.append(retirer);
      zone.append(item);
    });
  }

  dire(message, erreur = false) {
    this.formStatus.textContent = message;
    this.formStatus.classList.toggle('is-error', erreur);
  }

  async envoyer() {
    const donnees = new FormData(this.form);
    const note = Number(donnees.get('rating'));
    if (!note) return this.dire(window.BelleriveI18n.t("choisissez_une_note"), true);
    if (!String(donnees.get('text') || '').trim()) return this.dire(window.BelleriveI18n.t("ecrivez_quelques_mots_sur_le_produit"), true);
    if (!String(donnees.get('name') || '').trim()) return this.dire(window.BelleriveI18n.t("indiquez_votre_prenom"), true);

    this.submit.disabled = true;
    try {
      await this.lib.envoyerAvis(this.cfg.api, {
        rating: note,
        title: donnees.get('title') || '',
        text: donnees.get('text'),
        name: donnees.get('name'),
        website: donnees.get('website') || '',
        productId: this.cfg.productId,
        handle: this.cfg.handle,
        files: this.fichiers,
      }, (etape) => this.dire(etape));
      this.form.hidden = true;
      this.done.hidden = false;
    } catch (erreur) {
      this.dire(erreur.message || window.BelleriveI18n.t("une_erreur_est_survenue"), true);
    } finally {
      this.submit.disabled = false;
    }
  }
}

customElements.define('br-reviews-popup', ReviewPopup);
})();


/* ─────────────── Bouton « Laisser un avis » autonome ─────────────── */
(() => {
  if (customElements.get('bellerive-avis-formulaire')) return;

  const HINTS = ['', window.BelleriveI18n.t("tres_decue"), window.BelleriveI18n.t("decevant"), window.BelleriveI18n.t("correct"), window.BelleriveI18n.t("tres_bien"), window.BelleriveI18n.t("parfait")];

  /* Le fichier partagé peut arriver après ce script : on l'attend. */
  function bibliotheque() {
    if (window.BelleriveAvis) return Promise.resolve(window.BelleriveAvis);
    return new Promise((resolve) => {
      const minuteur = setInterval(() => {
        if (window.BelleriveAvis) { clearInterval(minuteur); resolve(window.BelleriveAvis); }
      }, 30);
    });
  }

  class ReviewForm extends HTMLElement {
    async connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.lib = await bibliotheque();

      this.cfg = JSON.parse(this.querySelector('[data-form-config]').textContent);
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('[data-form]');
      this.status = this.querySelector('[data-status]');
      this.submit = this.querySelector('[data-submit]');
      this.done = this.querySelector('[data-done]');
      this.files = [];

      this.querySelector('[data-open]').onclick = () => this.open();
      this.querySelectorAll('[data-close]').forEach((button) => {
        button.onclick = () => this.dialog.close();
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      this.bindStars();
      this.bindCounter();
      if (this.cfg.allowMedia) this.bindFiles();

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.send();
      });
    }

    open() {
      if (!this.cfg.api) {
        this.setStatus(window.BelleriveI18n.t("renseignez_lurl_de_lapi_dans_les_reglages_de_la_section"), true);
      }
      this.dialog.showModal();
    }

    bindStars() {
      const group = this.querySelector('[data-stars]');
      const hint = this.querySelector('[data-stars-hint]');
      // Les étoiles se remplissent jusqu'à celle survolée / sélectionnée.
      const paint = (value) => {
        group.classList.toggle('is-set', value > 0);
        group.querySelectorAll('label').forEach((label, index) => {
          label.style.color = index < value ? '' : '#dcdce6';
        });
      };
      group.querySelectorAll('input').forEach((input) => {
        input.addEventListener('change', () => {
          this.rating = Number(input.value);
          paint(this.rating);
          hint.textContent = HINTS[this.rating];
        });
      });
      group.querySelectorAll('label').forEach((label, index) => {
        label.addEventListener('mouseenter', () => paint(index + 1));
      });
      group.addEventListener('mouseleave', () => paint(this.rating || 0));
    }

    bindCounter() {
      const field = this.form.elements.text;
      const counter = this.querySelector('[data-counter]');
      field.addEventListener('input', () => {
        counter.textContent = `${field.value.length} / 3000`;
      });
    }

    bindFiles() {
      const input = this.querySelector('[data-files]');
      const drop = this.querySelector('[data-drop]');

      input.addEventListener('change', () => {
        this.addFiles(input.files);
        input.value = '';
      });

      ['dragenter', 'dragover'].forEach((type) =>
        drop.addEventListener(type, (event) => {
          event.preventDefault();
          drop.classList.add('is-over');
        })
      );
      ['dragleave', 'drop'].forEach((type) =>
        drop.addEventListener(type, () => drop.classList.remove('is-over'))
      );
      drop.addEventListener('drop', (event) => {
        event.preventDefault();
        this.addFiles(event.dataTransfer.files);
      });
    }

    addFiles(list) {
      const room = this.cfg.maxMedia - this.files.length;
      if (room <= 0) {
        this.setStatus(window.BelleriveI18n.t("number_fichiers_maximum", {number: this.cfg.maxMedia}), true);
        return;
      }
      for (const file of Array.from(list).slice(0, room)) {
        const isVideo = file.type.startsWith('video/');
        if (isVideo && !this.cfg.allowVideo) continue;
        if (isVideo && file.size > 100 * 1024 * 1024) {
          this.setStatus(window.BelleriveI18n.t("name_depasse_100_mo", {name: file.name}), true);
          continue;
        }
        this.files.push(file);
      }
      this.renderPreviews();
    }

    renderPreviews() {
      const wrap = this.querySelector('[data-previews]');
      wrap.replaceChildren();

      this.files.forEach((file, index) => {
        const item = document.createElement('div');
        item.className = 'br-preview';

        const url = URL.createObjectURL(file);
        const isVideo = file.type.startsWith('video/');
        const media = document.createElement(isVideo ? 'video' : 'img');
        media.src = url;
        if (isVideo) {
          media.muted = true;
          media.playsInline = true;
        } else {
          media.alt = '';
        }
        media.addEventListener('load', () => URL.revokeObjectURL(url), { once: true });
        item.append(media);

        if (isVideo) {
          const badge = document.createElement('span');
          badge.className = 'br-badge';
          badge.textContent = window.BelleriveI18n.t("video");
          item.append(badge);
        }

        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = '✕';
        remove.setAttribute('aria-label', window.BelleriveI18n.t("retirer_name", {name: file.name}));
        remove.onclick = () => {
          this.files.splice(index, 1);
          this.renderPreviews();
        };
        item.append(remove);

        wrap.append(item);
      });
    }

    setStatus(message, isError = false) {
      this.status.textContent = message;
      this.status.classList.toggle('is-error', isError);
    }

    async send() {
      const data = new FormData(this.form);
      const rating = Number(data.get('rating'));

      if (!rating) return this.setStatus(window.BelleriveI18n.t("choisissez_une_note"), true);
      if (!String(data.get('text') || '').trim()) {
        return this.setStatus(window.BelleriveI18n.t("ecrivez_quelques_mots_sur_le_produit"), true);
      }
      if (!String(data.get('name') || '').trim()) {
        return this.setStatus(window.BelleriveI18n.t("indiquez_votre_prenom"), true);
      }

      this.submit.disabled = true;
      try {
        // Toute la mécanique (compression, dépôt des fichiers, création de
        // l'avis) vit dans bellerive-avis.js, partagé avec le pop-up produit.
        await this.lib.envoyerAvis(this.cfg.api, {
          rating,
          title: data.get('title') || '',
          text: data.get('text'),
          name: data.get('name'),
          website: data.get('website') || '',
          productId: this.cfg.productId,
          handle: this.cfg.handle,
          files: this.files,
        }, (etape) => this.setStatus(etape));

        this.form.hidden = true;
        this.done.hidden = false;
      } catch (error) {
        this.setStatus(error.message || window.BelleriveI18n.t("une_erreur_est_survenue"), true);
      } finally {
        this.submit.disabled = false;
      }
    }
  }

  customElements.define('bellerive-avis-formulaire', ReviewForm);
})();

